module.exports = __webpack_public_path__ + "static/media/artist.48e62a8c.jpg";